import { useEffect, useState } from 'react';
import { observer } from "mobx-react-lite";
import { useParams } from "react-router-dom";

import Stack from '@mui/joy/Stack';
import Typography from '@mui/joy/Typography';
import Chip from '@mui/joy/Chip';


import WorkList from 'components/WorkList';
import { WorkItemType } from 'components/WorkListItem';

import useCollaborators from 'hooks/useCollaborators';
import useFHRequest from 'hooks/useFHRequest';
import useUserIdentity from 'hooks/useUserIdentity';

const IdentityAssignments = observer(() => {
    const { identityKey } = useParams();
    const {
        fetchIdentityCollaboratorsByManager,
        getIdentityCollaborators } = useCollaborators();
    const {
        fetchListClaimedByManager,
        getListClaimed } = useFHRequest();
    //    const { currentUser } = useAuth();
    const [requests, setRequests] = useState([] as WorkItemType[]);
    const [collabs, setCollabs] = useState([] as WorkItemType[]);
	const { currentIdentity } = useUserIdentity();

    const [loadingRequests, setLoadingRequests] = useState(false);
    const [loadingCollabs, setLoadingCollabs] = useState(false);
    const [fetchedCollabs, setFetchedCollabs] = useState(false);

    const status = 'active';



    // const _getCollabs = (status: string) => {
    //     if (status === 'active') {
    //         return activeCollaborators;
    //     } else if (status === 'snoozed') {
    //         return snoozedCollaborators;
    //     } else {
    //         return archivedCollaborators;
    //     }
    // };
    // useEffect(() => {
    //     const i = _getCollabs(status);
    //     setCollabs(i);
    // }, [status, activeCollaborators, snoozedCollaborators, archivedCollaborators]);

    /* load the requests */

    useEffect(() => {
        if(!currentIdentity?.key) return;
        if(!identityKey) return;
        if(loadingRequests) return;
        if (status === 'active') {
            setLoadingRequests(true);
            fetchListClaimedByManager(currentIdentity.key, identityKey)
                .finally(() => {
                    const c = getListClaimed(identityKey, '');
                    setRequests(c);
                    setLoadingRequests(false);
                });
        }
        else {
            setLoadingRequests(false);
            setRequests([] as WorkItemType[]);
        }

    }, [currentIdentity?.key, fetchListClaimedByManager, status]);

    // /* load teh collabs */
    useEffect(() => {
        if(!currentIdentity?.key) return;
        if(!identityKey) return;
        if(fetchedCollabs) return;
        setLoadingCollabs(true);
        fetchIdentityCollaboratorsByManager(currentIdentity.key, identityKey, 'collab')
            .then(() => {
                const i = getIdentityCollaborators(identityKey);
                console.log("i: ", i);
                setCollabs(i);
                setFetchedCollabs(true);
                setLoadingCollabs(false);
            });
        fetchIdentityCollaboratorsByManager(currentIdentity.key, identityKey, 'support')
            .then(() => {
                const i = getIdentityCollaborators(identityKey);
                console.log("i: ", i);
                setCollabs(i);
                setFetchedCollabs(true);
                setLoadingCollabs(false);
        });
    }, [fetchIdentityCollaboratorsByManager, getIdentityCollaborators]);


    const items = [...collabs, ...requests]
        .sort((a, b) => a.date_created > b.date_created ? 1 : -1);

    return (
        <Stack m={1}>
            <Stack spacing={3}>

                <Typography level="title-lg">
                    Assignments <Chip>{items.length}</Chip>
                </Typography>

                <Stack spacing={1}>
                    <WorkList
                        loading={loadingRequests || loadingCollabs}
                        title={<Typography>Assignments</Typography>}
                        paged={false}
                        items={items} />
                </Stack>

            </Stack>
        </Stack>
    );

});
export default IdentityAssignments;
